import api from "@/api";

export default {
  state: {
    salesCategoryPriceCompaniesData: [],
    saleCategoryPriceId: 0,
  },
  getters: {
    salesCategoryPriceCompaniesData: (state) => state.salesCategoryPriceCompaniesData.data,
    saleCategoryPriceId: (state) => state.saleCategoryPriceId,
  },
  mutations: {
    setSaleCategoryPriceCompanies: (state, data) => {
      state.salesCategoryPriceCompaniesData = data;
    },
    setSaleCategoryPriceId: (state, data) => {
      state.saleCategoryPriceId = data;
    },
  },
  actions: {
    getSaleCategoryCompanies: async ({ commit }, { saleCategoryPriceId, teamId }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/partials/sales-category-price-company-forms/${saleCategoryPriceId}`,
          { params: { team_id: teamId } }
        );
        const { data } = response;
        commit("setSaleCategoryPriceCompanies", data);
      } catch (err) {
        console.error(err);
      }
    },
    deleteSaleCategoryPrice: async (_, { id, teamId }) => {
      try {
        await api({ requiresAuth: true }).delete(
          `/v1/sales-category-prices/${id}`,
          { data: { team_id: teamId } }
        );
      } catch (err) {
        console.error(err);
      }
    },
    updateSaleCategoryPrice: async (_, { saleCategoryPriceId, provision, teamId }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/sales-category-prices/${saleCategoryPriceId}`,
          { agent_provision: provision, team_id: teamId }
        );
      } catch (err) {
        console.error(err);
      }
    },
  },
};
